<template>
    <v-app id="inspire">

        <!-- Top navigation -->
        <AppBar />

        <!-- Left navigation -->
        <NavigationDrawer />

        <!-- Content -->
        <v-main>

            <div v-show="!appStore.ShowLoaderMain">
                <slot></slot>
            </div>

            <div v-show="appStore.ShowLoaderMain" class="loader-overlay loader-w100">
                <div class="loader-large">
                    <img src="@assets/images/general/loader/oval.svg" alt="Loading">
                </div>
            </div>

        </v-main>

        <!-- Footer -->
        <!-- <v-footer>

            <div class="footer__company">2025 © NLB d. d.</div>

            <div class="footer__link" >
                Pogoji uporabe</div>
            <div class="footer__link"
               >
                Splošni pogoji za nakup na obroke</div>
            <div class="footer__link"
                >Varstvo
                osebnih podatkov</div>
            <div class="footer__link" >Piškotki</div>
            <div class="footer__link"
               >SISBON</div>

        </v-footer> -->

    </v-app>
</template>

<script setup lang="ts">
import NavigationDrawer from "@components/layout/navigation-drawer.vue";
import AppBar from "@components/layout/app-bar.vue";
import { useAppStore } from "@/app/store/app/app-store";

const appStore = useAppStore();
</script>
